/**
 * Trades WebSocket manager types
 * @module types/trades
 */

import type { WebSocketManagerConfig } from './websocket';
import type { BaseSubscriptionInfo } from './common';
import { api } from '../../generated/trades';

/**
 * Trade event types
 */
export enum TradeEventTypes {
  ORDER = 'order',
  POSITION = 'position',
  GTT_ORDER = 'gtt_order',
  POSITION_REFRESH = 'position_refresh',
}

/**
 * Trade event modes used in WebSocket messages
 */
export enum TradeEventMode {
  ORDER = 'O',
  POSITION = 'PO',
  GTT_ORDER = 'G',
  POSITION_REFRESH = 'PO_REF',
}

/**
 * Configuration for the Trades WebSocket manager
 */
export interface TradesWebSocketManagerConfig {
  /** WebSocket URL for trades feed */
  websocketUrl: string;
  /** Unique socket identifier */
  socketId: string;
  /** Custom protobuf decoder function */
  protobufDecoder?: (data: Uint8Array) => unknown;
  /** Base WebSocket configuration */
  websocketConfig: WebSocketManagerConfig;
}

/**
 * Trade data received from the WebSocket
 */
export type TradeData = api.trades.ITradeData;
export type GTTOrderUpdate = api.trades.IGttUpdate;

/**
 * Callback function for trade updates
 */
export type TradesCallback = (
  message: TradeData | null,
  error?: unknown,
) => void;

/**
 * Trades subscription info
 */
export interface TradesSubscriptionInfo extends BaseSubscriptionInfo {
  callback: TradesCallback;
  type: TradeEventTypes;
}
